module.exports = {
    GET_USERS_BASE_API: '/users',
    DATE_STRING_FORMAT: 'YYYY-MM-DD',
    DATA_TYPE_INDEX: {
        DataTableHeaders: 0,
        Data: 1
    }
};
